import React, { useEffect, useRef } from "react";
import * as THREE from "three";

export default function InteractiveBox() {
  const mountRef = useRef(null);
  const tooltipRef = useRef(null);

  useEffect(() => {
    const mount = mountRef.current;
    const width = mount.clientWidth;
    const height = mount.clientHeight;

    /** --- SCENE --- **/
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
    camera.position.set(2, 2, 4);

    /** --- RENDERER --- **/
    const renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setSize(width, height);
    renderer.setClearColor(0xffffff); // white background
    mount.appendChild(renderer.domElement);

    /** --- BOX --- **/
    const geometry = new THREE.BoxGeometry(1, 1, 1);
    const material = new THREE.MeshStandardMaterial({ color: "#3498db" });
    const box = new THREE.Mesh(geometry, material);
    box.name = "mainBox";
    scene.add(box);

    /** --- LIGHT --- **/
    const light = new THREE.HemisphereLight(0xffffff, 0x444444, 1);
    scene.add(light);

    /** --- RAYCASTER FOR INTERACTION --- **/
    const raycaster = new THREE.Raycaster();
    const mouse = new THREE.Vector2();

    function onMouseMove(e) {
      const rect = mount.getBoundingClientRect();
      mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
      mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
    }

    mount.addEventListener("mousemove", onMouseMove);

    /** --- TOOLTIP DIV --- **/
    const tooltip = tooltipRef.current;

    /** --- ANIMATION LOOP --- **/
    function animate() {
      requestAnimationFrame(animate);

      raycaster.setFromCamera(mouse, camera);
      const intersects = raycaster.intersectObjects(scene.children);

      let foundHover = false;

      if (intersects.length > 0) {
        const first = intersects[0].object;

        if (first.name === "mainBox") {
          foundHover = true;

          tooltip.style.display = "block";
          tooltip.style.left = mouse.x * (width / 2) + width / 2 + "px";
          tooltip.style.top = -mouse.y * (height / 2) + height / 2 + "px";

          tooltip.innerHTML = `
            <div><strong>Box Information</strong></div>
            <div>Size: 1 × 1 × 1</div>
            <div>Color: Blue</div>
          `;

          first.material.color.set("#1abc9c"); // highlight on hover
        }
      }

      if (!foundHover) {
        tooltip.style.display = "none";
        box.material.color.set("#3498db"); // reset color
      }

      renderer.render(scene, camera);
    }

    animate();

    return () => {
      mount.removeChild(renderer.domElement);
    };
  }, []);

  return (
    <div style={{ position: "relative", width: "100%", height: "500px" }}>
      <div ref={mountRef} style={{ width: "100%", height: "100%" }} />

      {/* Tooltip HTML */}
      <div
        ref={tooltipRef}
        style={{
          position: "absolute",
          display: "none",
          padding: "8px",
          background: "rgba(0,0,0,0.75)",
          color: "white",
          fontSize: "13px",
          borderRadius: "4px",
          pointerEvents: "none",
        }}
      />
    </div>
  );
}
